module.exports = __webpack_public_path__ + "img/Acc_Logo_White_Purple_RGB.9de92a29.png";